import React from 'react'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'

import DataTable from 'Shared/Components/DataTable'

const AlertMonitor = ({ data }) => {
  const { t } = useTranslation()

  return (
    <div style={{ width: "100%", height: "100%", backgroundColor: "#FFFFFF", borderRadius: "10px", display: "flex", flexDirection: "column", overflow: "auto", padding: "10px" }}>
      <div><b>Recent Alert</b></div>

      <Paper elevation={0} sx={{ flex: 1, display: "flex", flexFlow: "column", overflow: "auto" }}>
        <DataTable
          data={data}
          columns={{
            "datetime": { "label": t("general_datetime"), "sorting": false, "nowrap": true },
            "message": { "label": t("alert_message"), "sorting": false, "nowrap": true },
            "target": { "label": t("alert_target"), "sorting": false, "nowrap": true },
            "status": { "label": t("alert_status"), "sorting": false, "nowrap": true },
          }}
        />
      </Paper>
    </div>
  )
}

export default AlertMonitor